import { Fragment, memo } from 'react'

import { Table } from '@mantine/core'
import * as _ from 'lodash-es'

import { CryptoLookupTxLinkOld } from '@repo/common/components/CryptoLookupTxLink'
import { useListCryptoContracts } from '@repo/common/queries/crypto_contracts'

import { type ActiveFundType, useListFunds } from '../../queries/labs/funds'
import { isActiveFund } from '../../queries/labs/products'

// eslint-disable-next-line max-lines-per-function
export const ShowAddresses = memo(function ShowAddresses() {
  const { data: funds } = useListFunds()
  const { data: contract_data } = useListCryptoContracts()
  const contracts = contract_data?.contracts ?? []
  const base_url = contract_data?.contract_base_url ?? ''

  const by_category = _.groupBy(contracts, 'category')

  const tradable_funds = _.filter(funds, (f): f is ActiveFundType =>
    isActiveFund(f.symbol),
  )

  return (
    <Table>
      <Table.Tbody>
        {_.sortBy(tradable_funds, 'symbol').map((p) => (
          <Fragment key={p.symbol}>
            <Table.Tr>
              <Table.Td ta="right">{p.symbol}</Table.Td>
              <Table.Td>
                <CryptoLookupTxLinkOld
                  address={p.token_address}
                  base_url={base_url}
                >
                  {p.token_address}
                </CryptoLookupTxLinkOld>
              </Table.Td>
            </Table.Tr>
          </Fragment>
        ))}
        {_.map(by_category, (group) =>
          _.sortBy(group, 'name').map((c) => (
            <Table.Tr key={c.name}>
              <Table.Td ta="right">{c.symbol || c.name}</Table.Td>
              <Table.Td>
                <CryptoLookupTxLinkOld address={c.address} base_url={base_url}>
                  {c.address}
                </CryptoLookupTxLinkOld>
              </Table.Td>
            </Table.Tr>
          )),
        )}
      </Table.Tbody>
    </Table>
  )
})
